import { render, staticRenderFns } from "./genres.vue?vue&type=template&id=f356e586"
import script from "./genres.vue?vue&type=script&lang=js"
export * from "./genres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports